import { BaseSelectorOption } from '@/types';
import { Chip, Divider, Link } from '@mui/material';
import { Component } from 'react';
import { withLocale, WithLocaleProps } from '../providers/LocaleProvider';
import AddIcon from '../resources/images/icons-add.svg';
import TickIcon from '../resources/images/icons-check.svg';
import ChevronDownIcon from '../resources/images/icons-chevron-down.svg';
import ChevronUpIcon from '../resources/images/icons-chevron-up.svg';
import { Button } from './Button';

interface ChipContainerProps extends WithLocaleProps {
  items: BaseSelectorOption[];
  limit?: number;
  showDivider?: boolean;
  showAll?: boolean;
  selectedItems?: BaseSelectorOption[];
  onChange?: (e: React.MouseEvent, selectedItems: BaseSelectorOption[]) => void;
}

interface ChipContainerState {
  showAll: boolean;
  selectedItems: BaseSelectorOption[];
}

class ChipContainerBase extends Component<ChipContainerProps, ChipContainerState> {
  static defaultProps = {
    limit: 5,
  };

  constructor(props: ChipContainerProps) {
    super(props);

    this.state = {
      showAll: props.showAll ? props.showAll : false,
      selectedItems: props.selectedItems ? props.selectedItems : [],
    };
  }

  componentDidUpdate(prevProps: ChipContainerProps) {
    if (prevProps.selectedItems !== this.props.selectedItems)
      this.setState({ selectedItems: this.props.selectedItems || [] });
  }

  onShowMoreLess(e: React.MouseEvent) {
    const { showAll } = this.state;

    this.setState({ showAll: !showAll });
  }

  onSelectAll(e: any) {
    e.preventDefault();

    const { items, onChange } = this.props;
    const { selectedItems } = this.state;

    this.setState({ selectedItems: this.isAllSelected() ? [] : items }, () => {
      if (onChange) onChange(e, this.state.selectedItems);
    });
  }

  isAllSelected() {
    const { items } = this.props;
    const { selectedItems } = this.state;
    return items.length === selectedItems.length;
  }

  onChipSelect(e: React.MouseEvent, item: BaseSelectorOption) {
    const { onChange } = this.props;

    let { selectedItems } = this.state;
    if (selectedItems.includes(item)) selectedItems = selectedItems.filter((i) => i !== item);
    else selectedItems.push(item);

    this.setState({ selectedItems });

    if (onChange) onChange(e, selectedItems);
  }

  render() {
    const { items, limit, showDivider = true } = this.props;
    const { showAll, selectedItems } = this.state;

    return (
      <div className='klaro-chipcontainer'>
        {items.slice(0, showAll ? items.length : limit).map((i) => (
          <Chip
            className={'klaro-chip' + (selectedItems.includes(i) ? ' klaro-chip--selected' : '')}
            label={i.name}
            deleteIcon={selectedItems.includes(i) ? <TickIcon /> : <AddIcon />}
            onClick={(e) => this.onChipSelect(e, i)}
            onDelete={(e) => this.onChipSelect(e, i)}
            key={Math.random().toString(36).substring(7)}
            component='div'
          />
        ))}
        {showAll && (
          <Link className='klaro-chipcontainer_selectalllink' onClick={this.onSelectAll.bind(this)}>
            {this.isAllSelected()
              ? this.props.translate('common.deselectAll')
              : this.props.translate('common.selectAll')}
          </Link>
        )}
        {items.length > (limit || 0) ? (
          <div className='klaro-chipcontainer_showmore'>
            <Button
              autoFocus
              label={
                showAll
                  ? this.props.translate('common.showLess')
                  : this.props.translate('common.showAll')
              }
              variant='simple'
              size='sm'
              endIcon={showAll ? <ChevronUpIcon /> : <ChevronDownIcon />}
              onClick={this.onShowMoreLess.bind(this)}
            />
          </div>
        ) : showDivider ? (
          <Divider sx={{ marginTop: '20px' }} />
        ) : null}
      </div>
    );
  }
}

export const ChipContainer = withLocale(ChipContainerBase);
